import { api } from "./client";
import type { PanelUser } from "../store/auth.store";

export interface RefreshResponse {
  accessToken: string;
  refreshToken: string;
  expiresAt: string;
  user: PanelUser;
}

export const authApi = {
  refresh: (refreshToken: string) =>
    api.post<RefreshResponse>("/auth/refresh", { refreshToken }).then((r) => r.data),

  logout: (refreshToken: string) =>
    api.post("/auth/logout", { refreshToken }).then(() => undefined),

  me: () => api.get<PanelUser>("/auth/me").then((r) => r.data),
};
